import { call, put } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { Set } from '../../../../ts/models/Set';
import { ICustomViewInfo } from '../../../../ts/ServerApi/CustomViews/ICustomViewInfo';
import { DeleteCustomViewsAction } from '../../../../ts/services/customViews/DeleteCustomViewsAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { DeleteCustomViewAction } from '../../../actions/spaces/customViews/DeleteCustomViewAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleDeleteCustomViewAction(action: DeleteCustomViewAction) {
  try {
    yield call(executeDeleteCustomViewAction, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeDeleteCustomViewAction(items: ICustomViewInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  const deleteCustomViewService = ServiceLocator.get<DeleteCustomViewsAction>('DeleteCustomViewsAction');
  return deleteCustomViewService.executeWithContext(Set.fromIdItemArray(items), context);
}
